import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import homeAPI from '~/api/HomeAPI';
import FormContact from '~/components/FormContact';
import BannerHome from './components/BannerHome';
import CategoryHome from './components/CategoryHome';
import CustomerHome from './components/CustomerFeedbackHome';
import IntroductionSpa from './components/IntroductionSpa';
import LatestBooking from './components/LatestBooking';
import ServiceSpa from './components/ServiceSpa';
import styles from './Home.module.scss';
import DownloadApp from './components/DownloadApp';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import { useNavigate } from 'react-router-dom';
import config from '~/config';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';

const cx = classNames.bind(styles);

const defaultImages = [
    {
        image: IMAGES.ImageBanner01,
    },
    {
        image: IMAGES.ImageBanner02,
    },
    {
        image: IMAGES.ImageBanner03,
    },
];

function Home() {
    const navigate = useNavigate();

    const [feedbacks, setFeedbacks] = useState(null);
    const [hotServices, setHotServices] = useState([]);
    const [services, setServices] = useState([]);
    const [latestBooking, setLatestBooking] = useState({});
    const [listNameService, setListNameService] = useState([]);
    const [bannerList, setBannerList] = useState(defaultImages || []);
    const [bannerMobileList, setBannerMobileList] = useState(defaultImages || []);

    const userInfo = useSelector((state) => state.user.userInfo);
    const isLogin = userInfo?.id || '';

    const phone_booking = localStorage.getItem('phone_booking');

    const phone = userInfo?.phone || phone_booking;

    const getHomeInformation = async () => {
        try {
            const res = await homeAPI.currentHomeSetting(phone);
            setFeedbacks(res.feedbacks);
            setHotServices(res.category_service);
            setServices(res.service);
            setLatestBooking(res.booking);
            setBannerList(res.banner_images);
            setBannerMobileList(res?.banner_images_mobile);
            let name_services = [];
            if (res.booking.booking_details?.length) {
                for (const service of res.booking.booking_details) {
                    name_services.push(`${service.title} (x${service.count})`);
                }
            }
            setListNameService(name_services);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getHomeInformation();
        document.body.classList.remove('time-picker-booking-custom');
        // eslint-disable-next-line
    }, [isLogin]);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangChu');
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {/* DESKTOP UI */}
            <div className={cx('desktop')}>
                <BannerHome bannerList={bannerList} isDesktop={true} />
                {latestBooking?.id ? (
                    <LatestBooking
                        getHomeInformation={getHomeInformation}
                        latestBooking={latestBooking}
                        listNameService={listNameService}
                        isDesktop={true}
                    />
                ) : null}
                <ServiceSpa data={hotServices} />
                <IntroductionSpa />
                <CategoryHome data={services} />
                <CustomerHome data={feedbacks} />
                <FormContact />
                <DownloadApp />
            </div>

            {/* MOBILE UI */}
            <div className={cx('mobile')}>
                <div className={cx('sayHi')}>
                    <div className={cx('avatar')}>
                        <img src={userInfo?.avatar || IMAGES.NewLogo} alt="" />
                    </div>
                    <div className={cx('info')}>
                        <h3>{isLogin ? `Hi, ${userInfo?.fullname || userInfo?.phone}` : 'Hi'}</h3>
                        <p>Welcome to Beauty-ms!</p>
                    </div>
                </div>
                <BannerHome bannerList={bannerMobileList} isDesktop={false} />
                <div className={cx('btnList')}>
                    <div className={cx('btn')} onClick={() => navigate(config.routes.createSchedulePage)}>
                        <button>
                            <img src={SVGS.IconCalendar} alt="icon-calendar" />
                        </button>
                        <span>Schedule</span>
                    </div>
                    <div className={cx('btn')} onClick={() => navigate(config.routes.historyBooking)}>
                        <button>
                            <img src={SVGS.IconVector} alt="icon-vector" />
                        </button>
                        <span>Booking history</span>
                    </div>
                    <div className={cx('btn')}>
                        <button>
                            <img src={SVGS.IconPhonePurple} alt="icon-phone" />
                        </button>
                        <span>Consulting</span>
                    </div>
                    <div className={cx('btn')} onClick={() => navigate(config.routes.topUp)}>
                        <button>
                            <img src={IMAGES.ImageEmptyWallet} alt="icon-badge" />
                        </button>
                        <span>Deposit</span>
                    </div>
                </div>
                {latestBooking?.id ? (
                    <LatestBooking
                        getHomeInformation={getHomeInformation}
                        latestBooking={latestBooking}
                        listNameService={listNameService}
                        isDesktop={false}
                    />
                ) : null}
                <CategoryHome data={services} />
                <CustomerHome data={feedbacks} />
                <ServiceSpa data={hotServices} />
                <IntroductionSpa />
                <FormContact />
                <DownloadApp />
            </div>
        </>
    );
}

export default Home;
